import { gql } from "@apollo/client";

export const PET_UPDATE = gql`
  mutation update($id: String!, $file: Upload, $pet: UpdatePetInputV2!) {
    updatePetV2(
      id: $id,
      file: $file,
      updatePet: $pet,
    ) {
      pet {
        id,
        name,
        image,
        species,
        speciesName,
        breed,
        breedName,
        birthdate,
        age,
        gender,
        isDesexed,
        idColor,
        colorName,
        medicalRecord{
          city,
          clinicName,
        },
        medicalRecordsSeenByVet,
        microchip {
          microchipNumber,
          details {
            title,
            description,
          },
        }
      }
    }
  }`;
